import styled from 'styled-components'

export const InputStyles = styled.input`
padding: 0.25em 0.5em;
border: 1px solid #ccc;
background-color:#242f40;
color: #ccc;
`
